import { render, staticRenderFns } from "./move-site-modal.vue?vue&type=template&id=2880294e&scoped=true"
import script from "./move-site-modal.vue?vue&type=script&lang=js"
export * from "./move-site-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880294e",
  null
  
)

export default component.exports